import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { compose, withProps, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import Payment from "./Payment";
var enhancer = compose(withProps(function (_ref) {
  var applicationFee = _ref.applicationFee,
    appPrice = _ref.appPrice,
    extraCharges = _ref.extraCharges;
  var renderOriginalApplicationFee = applicationFee && appPrice !== applicationFee.original_price;
  var applicationFeeTip = applicationFee && appPrice === applicationFee.original_price ? 'Application Fee' : 'Discounted Application Fee';
  var perApplicationCharges = extraCharges.filter(function (entry) {
    return entry.charge_type === 'per_application';
  });
  var perStudentCharges = extraCharges.filter(function (entry) {
    return entry.charge_type === 'per_student';
  });
  return {
    renderOriginalApplicationFee: renderOriginalApplicationFee,
    applicationFeeTip: applicationFeeTip,
    perApplicationCharges: perApplicationCharges,
    perStudentCharges: perStudentCharges
  };
}), setPropTypes({
  applicationFee: PropTypes.object,
  applicationFeeTip: PropTypes.string,
  appPrice: PropTypes.string,
  extraCharges: PropTypes.array,
  info: PropTypes.object,
  perApplicationCharges: PropTypes.array,
  perStudentCharges: PropTypes.array,
  renderOriginalApplicationFee: PropTypes.bool
}));
export default enhancer(Payment);